<template>
  <li class="room card w-100 bg-light">
      <div class="row">
        <div class="col-1">
          <div
            class="mode w-100 h-100 rounded-left d-flex align-items-center justify-content-center"
            :class="[mode === 'prod' ? prodClasses : testClasses]">
            {{ mode }}
          </div>
        </div>
        <div class="col-4">
          <div class="card-block my-2">
            <h5 class="title card-title mb-0">
              {{ room.name }}
            </h5>
            <p class="title-discription card-text">
              by {{ room.creatorName }}
            </p>
            <p class="title-discription card-text">
              at {{ createdAt }}
            </p>
          </div>
        </div>
        <div class="col-3">
          <rooms-item-status
            class="h-100 d-flex align-items-center justify-content-center"
            :room="room"
            :mode="mode">
          </rooms-item-status>
        </div>
        <div class="col-4">
          <rooms-item-buttons
            class="h-100 d-flex align-items-center justify-content-center"
            :mode="mode"
            :rid="room.id">
          </rooms-item-buttons>
        </div>
        <!-- <div class="col-1"> -->
        <!--   <div class="h-100 d-flex align-items-center justify-center"> -->
            <!-- <button class="btn btn-sm btn-secondary"> -->
            <!--   방삭제 -->
            <!-- </button> -->
          <!-- </div> -->
        <!-- </div> -->
      </div>
  </li>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import RoomsItemButtons from './RoomsItemButtons'
import RoomsItemStatus from './RoomsItemStatus'
import l from '@/vendor/logger'

export default {
  name: 'RoomsItem',

  props: {
    room: Object,
    mode: String
  },

  data () {
    return {
      testClasses: 'btn btn-secondary',
      prodClasses: 'btn bg-danger progress-bar progress-bar-striped progress-bar-animated'
    }
  },

  created () {
  },

  mounted () {
    l.d('RoomsItem/mounted', this.room, this.mode)
  },

  computed: {
    ...mapGetters('rooms', [
      'formattedCreatedAt'
    ]),
    ...mapState('rooms', [
      'prodRooms',
      'testRooms'
    ]),
    createdAt () {
      return this.formattedCreatedAt
        ? this.formattedCreatedAt(`${this.mode}Rooms`)(this.room.id)
        : ''
    }
  },

  components: {
    RoomsItemButtons,
    RoomsItemStatus
  }
}
</script>

<style scoped>
.room {
  & .mode {
    color: white;
  }

  & .title-discription {
    margin-bottom: 0;
    font-size: .8rem;
  }
}
</style>
